import React from "react";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";

const Pagination = ({ page, totalPages, handlePageChange }) => {
  const PaginationButton = ({ children, onClick, disabled }) => (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`flex h-8 w-8 items-center justify-center rounded-md ${
        disabled ? "text-gray-600" : "text-gray-300 hover:bg-orangePrimary/35"
      }`}
    >
      {children}
    </button>
  );

  const PageNumber = ({ number, isActive }) => (
    <div
      className={`flex h-8 w-8 cursor-pointer items-center justify-center rounded-md ${
        isActive
          ? "bg-orangePrimary/30 border  border-orangePrimary text-white"
          : " text-gray-300 hover:bg-orangePrimary/25"
      }`}
      onClick={() => handlePageChange(number)}
    >
      {number}
    </div>
  );

  const getPageNumbers = () => {
    const pages = [];

    // Always show the first page
    pages.push(1);

    // Show the immediate range around the current page
    if (page > 2) {
      pages.push(2);
    }

    if (page > 3) {
      pages.push("...");
    }

    if (page > 1 && page < totalPages) {
      pages.push(page);
    }

    if (page + 1 < totalPages) {
      pages.push(page + 1);
    }

    if (page + 2 < totalPages) {
      pages.push("...");
    }

    // Always show the last page
    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="mt-4 flex items-center justify-end">
      <div className="flex items-center space-x-1 rounded-md p-1">
        {/* Previous button */}
        <PaginationButton
          onClick={() => handlePageChange(page - 1)}
          disabled={page === 1}
        >
          <MdChevronLeft size={20} />
        </PaginationButton>

        {/* Page numbers */}
        {pageNumbers.map((pageNumber, index) =>
          pageNumber === "..." ? (
            <div
              key={index}
              className="flex h-8 w-8 items-center justify-center text-gray-600"
            >
              ...
            </div>
          ) : (
            <PageNumber
              key={pageNumber}
              number={pageNumber}
              isActive={pageNumber === page}
            />
          )
        )}

        {/* Next button */}
        <PaginationButton
          onClick={() => handlePageChange(page + 1)}
          disabled={page === totalPages}
        >
          <MdChevronRight size={20} />
        </PaginationButton>
      </div>
    </div>
  );
};

export default Pagination;
